<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>
      
      <div class="deposit-query-workspace">
        <aside v-if="showContextPanel" class="deposit-query-context-panel">
          <b-card no-body class="deposit-query-tree-card">
            <div class="deposit-query-panel-heading">
              <span><AppIcon name="account_tree" /> Ubicaciones</span>
              <b-button variant="link" class="deposit-query-panel-toggle" @click="showContextPanel = false" v-b-tooltip.hover title="Ocultar ubicaciones">
                <AppIcon name="chevron-left" />
              </b-button>
            </div>
            <div class="deposit-query-selector deposit-query-selector--panel">
              <b-tabs class="deposit-query-selector__tabs" nav-class="deposit-query-selector__nav" content-class="deposit-query-selector__content">
                <b-tab active>
                  <template #title><AppIcon name="inventory_2" class="mr-1" /> Productos</template>
                  <div class="deposit-query-selector__form">
                    <FindObject render="search"
                                type="products"
                                @select-object="loadProducts($event)"
                                :valueID="filters.products_id"
                                :key="filters.products_compound_id"
                                :where="conditionProductsControlStock"/>
                    <div class="deposit-query-selector__context">
                      <AppIcon name="info" />
                      <span>Seleccioná un producto.</span>
                    </div>
                  </div>
                </b-tab>
                <b-tab v-if="parameters.haveProductsCompound">
                  <template #title><AppIcon name="category" class="mr-1" /> Compuestos</template>
                  <div class="deposit-query-selector__form">
                    <FindObject render="search"
                                type="productsCompound"
                                @select-object="loadProductsCompound($event)"
                                :valueID="filters.products_compound_id"
                                :key="filters.products_id"
                                :where="conditionProductsCompoundActive"/>
                    <div class="deposit-query-selector__context">
                      <AppIcon name="info" />
                      <span>Seleccioná un producto compuesto.</span>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
            <div v-if="!treeLoader" class="deposit-query-tree-body">
              <vue-tree-list
                @click="selectedItem"              
                :model="depositsTree"
                v-bind:default-expanded="true"              
                v-if="deposits && deposits.length"
                class="deposit-query-tree-custom"
              >                      
                <template v-slot:leafNameDisplay="slotProps">                
                  <span>
                    &nbsp;&nbsp;{{ slotProps.model.name }}
                  </span>
                </template>              

                <span class="icon" slot="treeNodeIcon"><AppIcon name="warehouse" />&nbsp;</span>
                <span class="icon" slot="leafNodeIcon"><AppIcon name="location_on" />&nbsp;</span>
              </vue-tree-list>  
              <EmptyState v-else icon="warehouse" title="No hay ubicaciones" description="Consultá un producto para cargar la estructura de depósitos." />
            </div>
            <div class="tree-deposit-query deposit-query-tree-body" v-else>
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </b-card>         
        </aside>

        <div v-else class="deposit-query-context-collapsed" @click="showContextPanel = true" v-b-tooltip.hover.right title="Mostrar ubicaciones">
          <AppIcon name="chevron-right" />
          <span>Ubicaciones</span>
        </div>

        <main v-if="deposits && deposits.length" class="deposit-query-results" :class="{ 'deposit-query-results--expanded': !showContextPanel }">
          <b-card class="deposit-query-results-card">
            <b-row>
              <b-col md="7" class="mb-2 mb-md-0">
                <b-form-radio-group v-model="filters.typeQuery" 
                                    :options="optTypeQuery" 
                                    @input="setTypeQuery(treeSelectItem)"
                                    class="deposit-query__view-modes">
                </b-form-radio-group>            
              </b-col>
              <b-col md="5">              
                <div class="deposit-query__switches">
                  <b-form-checkbox  v-model="filters.viewUnitSale"  
                                    switch 
                                    size="sm"
                                    @input="saveViewUnitStorage()">
                    Ver en unidad de venta
                  </b-form-checkbox>   
                  <b-form-checkbox  v-model="filters.showWithoutStock"  
                                    switch 
                                    size="sm" 
                                    @input="setTypeQuery(treeSelectItem)"
                                    v-if="filters.typeQuery == 'group'">
                    Mostrar Productos Sin Stock
                  </b-form-checkbox>   
                </div>
              </b-col>
              <b-col md="12" class="mt-1">
                <b-table class="app-table mb-0"
                        stacked="md"
                        responsive
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        :busy="table.isBusy"   
                        v-if="table.items.length || table.isBusy">

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>
                    
                    <template v-slot:cell(date)="data">
                      <div v-if="data.item.operation">
                        {{moment(data.item.operation.date).format('DD/MM/YYYY')}}
                      </div>
                    </template>   

                    <template v-slot:cell(productCode)="data">
                      <div v-html="getDetailCode(data.item)"></div>
                    </template>     

                    <template v-slot:cell(productName)="data">
                      <div v-html="getDetailName(data.item)"></div>
                    </template>   

                    <template v-slot:cell(operation)="data">                                 
                      <div v-if="data.item.operation && data.item.operation.type">
                        {{data.item.operation.type.name}} #{{data.item.operation.number}}                        
                      </div>
                    </template>

                    <template v-slot:cell(quantity)="data">     
                      <span v-if="filters.typeQuery == 'mov'">                            
                        {{data.item.type_balance}} {{formatQuantity(getDisplayQuantity(data.item))}}
                      </span>
                      <span v-else>                            
                        {{formatQuantity(getDisplayQuantity(data.item))}}
                      </span>                  
                      <span v-if="getDisplayUnitReference(data.item)">{{getDisplayUnitReference(data.item)}}</span>
                    </template>

                    <template v-slot:cell(location)="data">
                      <DepositLocationLabel :location="data.item.location" />
                    </template>                

                </b-table>
                <EmptyState v-else icon="inventory_2" title="Sin existencias para mostrar" description="Elegí un producto y una ubicación para consultar el stock." />
              </b-col>              
              <b-col md="12" v-if="table.items.length && !table.isBusy">
                <hr>
                <div class="deposit-stock-total">
                  <b-row>
                    <b-col md="10">
                      <div class="deposit-stock-total-title">
                        TOTAL STOCK
                      </div>
                    </b-col>
                    <b-col md="2" class="text-right">
                      <span v-html="getStockTotal()"></span>
                    </b-col>
                  </b-row>
                </div>
              </b-col>              
            </b-row>
          </b-card>
        </main>
      </div>
      

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav v-if="table.tablePaginate">
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.tablePaginate.total"
                            :per-page="table.tablePaginate.per_page"
                            v-model="table.currentPage"
                            @input="filterReport()" />
            </nav>
          </b-col>          
        </b-row>
      </b-card>
  
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Funciones from '@/handler/funciones' 
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject' 
  import Param from '@/config/parameters'
  import Storage from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  import Vue from 'vue'
  import { VueTreeList, Tree } from 'vue-tree-list'
  Vue.use(VueTreeList)  

  export default {
    components: {
      FindObject,
      VueTreeList,
      TabHeaderActions,
    },    
    data: () => {
      return {      
        access: {
          module_id: Modules.DEPOSITOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudDepositsQuery',
          elements: {}
        }, 
        deposits: null,
        depositsTree: new Tree([]),
        table : {
          items: [],
          fields: [],
          isBusy: false,
          currentPage: 1,
          perPage: 0,
          tablePaginate: null,
        },     
        filters: {
          products: null,
          products_id: 0,
          products_compound: null,
          products_compound_id: 0, 
          location_id: 0,      
          type: 'products',
          typeQuery: 'group',
          showWithoutStock: false,
          viewUnitSale: false,
        },              
        treeLoader: false,
        treeSelectItem: null,
        showContextPanel: true,
        keyForceUpdate: 0,            
        optTypeQuery: [
          { text: 'Agrupado por Productos', value: 'group'},
          { text: 'Movimiento de Entrada y Salida', value: 'mov'},
        ],
        parameters: {
          haveProductsCompound: Helper.hasParametersAccess(Param.P30),
        }
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
      this.restoreViewUnitStorage()
    },
    computed: {
      // CONDITIONS SELECT  
      conditionProductsCompoundActive() {
        return [{field: 'active', condition: true}];
      }, 
      conditionProductsControlStock() {
        return [
          {field: 'control_stock', condition: true},
        ];
      },
    },  
    mounted() {
      this.loadFieldTable()
    },
    methods: {
      loadFieldTable() {
        this.table.fields = []
        
        if(this.filters.typeQuery=='mov') {
          this.table.fields.push({key: 'date', label: 'Fecha', class: 'align-middle'})
          this.table.fields.push({key: 'operation', label: 'Operación', class: 'align-middle'})
        }

        this.table.fields.push({key: 'location', label: 'Ubicación', sortable: true, class: 'align-middle'}) 
        this.table.fields.push({key: 'productCode', label: 'Código', class: 'align-middle'})
        this.table.fields.push({key: 'productName', label: 'Producto', class: 'align-middle'})                           
        this.table.fields.push({key: 'quantity', label: 'Cantidad', class: 'align-middle text-right'})        
      },
      getRowCount (items) {
        return items.length
      },

      forceUpdate() {
        this.keyForceUpdate = this.keyForceUpdate + 1
      },

      loadProducts (object) {        
        if(object){
          this.filters.products = object
          this.filters.products_id = object.id           
          
          this.filters.products_compound = null
          this.filters.products_compound_id = 0

          this.filters.type = 'products'

          this.filterReport()
        } else {
          this.filters.products = null
          this.filters.products_id = 0
        }
      },
      loadProductsCompound (object) {        
        if(object){
          this.filters.products_compound = object
          this.filters.products_compound_id = object.id        

          this.filters.products = null
          this.filters.products_id = 0

          this.filters.type = 'products_compound'

          this.filterReport()
        } else {
          this.filters.products_compound = null
          this.filters.products_compound_id = 0
        }
      },

      loadDeposits() {                
        var result = serviceAPI.filtrarActivityGroupDeposit(this.filters)
        
        result.then((response) => {          
          this.treeLoader = false
          
          this.deposits = [];  
          this.depositsTree = new Tree(this.deposits);  

          var data = response.data
          if(data.length) {
            var arrDeposits = []
            data.forEach(element => {                         
              var deposit_id = 0
              var deposit_name = 'SIN DEPOSITO'
              if(element.location.zone.deposit) {
                deposit_id = element.location.zone.deposit.id
                deposit_name = element.location.zone.deposit.name + ' (' + element.location.zone.deposit.reference + ')'
              }

              arrDeposits.push({
                id: deposit_id,
                name: deposit_name,
                zone_id: element.location.zone_id,
                zone: {
                  id: element.location.id,
                  name: element.location.zone.reference + ' | ' + element.location.reference,
                }
              })
            });
              
            arrDeposits = Funciones.sortArrayInteger(arrDeposits,'zone_id','asc')              
            
            var groupDeposit = []            
            arrDeposits.forEach(element => {
              if(groupDeposit[element.id] == undefined) {
                groupDeposit[element.id] = [] 
                groupDeposit[element.id].id = element.id
                groupDeposit[element.id].name = element.name
                groupDeposit[element.id].children = []
              }
            });            
            groupDeposit = groupDeposit.filter(Boolean)
            
            this.configTree(groupDeposit, arrDeposits)
          }           
        })
        .catch(error => {                  
          this.treeLoader = false
          this.$awn.alert(Error.showError(error))
        });    
      },      

      configTree(group, data) { 
        this.deposits = []             

        group.forEach((element, index) => {                                                                    
          this.deposits.push({            
            id: element.id,                  
            name: element.name,            
            dragDisabled: true,
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,                     
            children: [],
          })

          this.getChildren(this.deposits[index], data)
        })                  

        this.depositsTree = new Tree(this.deposits)
      },
      getChildren(obj, data) {     
        if(data) {        
          data.forEach(element => {        
            if(obj.id == element.id) {
              var existe = false
              obj.children.forEach(item => {
                if(item.id == element.zone.id) {
                  existe = true
                }
              });

              if(!existe) {
                obj.children.push({
                  id: element.zone.id,      
                  name: element.zone.name,                
                  dragDisabled: true,
                  addTreeNodeDisabled: true,
                  addLeafNodeDisabled: true,
                  editNodeDisabled: true,
                  delNodeDisabled: true,                  
                  isLeaf: true,                            
                })    
              }                                  
            }  
          });     
        }   
      },
      selectedItem(params) {     
        if(params.isLeaf) {          
          this.filterReport(params.id, false)
          this.treeSelectItem = params
        } else {
          this.filterReport(null, false)
          this.treeSelectItem = null          
        }       
      },

      setTypeQuery(params) {
        if(this.filters.typeQuery != 'group') {
          this.filters.showWithoutStock = false
        }

        if(params) {
          this.filterReport(params.id, false)    
        } else {
          this.filterReport(null, false)    
        }
      },

      filterReport(location_id, loadDeposits = true) {                
        if(!this.filters.products_compound_id && !this.filters.products_id) {
          this.$awn.alert("No se seleccionó el producto.")
          this.deposits = null
          this.table.items = []          
          return false
        }

        this.filters.location_id = location_id

        if(loadDeposits) { 
          this.deposits = null
          this.treeLoader = true
        }

        this.table.isBusy = true        
        var result = serviceAPI.filtrarActivity(this.filters, this.table.currentPage)

        result.then((response) => {          
          var data = response.data.data          
          this.table.items = data          
          this.table.isBusy = false

          this.table.tablePaginate = response.data

          this.loadFieldTable()

          if(loadDeposits) {
            this.loadDeposits()
          }          
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });                
      },
      getStockTotal() {
        var total = this.table.tablePaginate.total_quantity
        if(this.filters.viewUnitSale && this.table.tablePaginate.total_quantity_sale !== undefined) {
          total = this.table.tablePaginate.total_quantity_sale
        }

        var unitRef = ''
        if(this.filters.viewUnitSale && this.table.tablePaginate.unit_measurement_sale_reference) {
          unitRef = this.table.tablePaginate.unit_measurement_sale_reference
        } else if(this.table.items.length && this.table.items[0].unit_measurement) {
          unitRef = this.table.items[0].unit_measurement.reference
        }
        
        if(parseFloat(total)<0) {
          total = '<span class="text-danger">' + this.formatQuantity(total) + " " + unitRef + "</span>"
        } else {
          total = '<span class="text-success">' + this.formatQuantity(total) + " " + unitRef + "</span>"
        }                   
        
        return total
      },
      getDisplayQuantity(item) {
        if(this.filters.viewUnitSale && item && item.quantity_sale !== undefined && item.quantity_sale !== null) {
          return item.quantity_sale
        }
        return item ? item.quantity : 0
      },
      getDisplayUnitReference(item) {
        if(this.filters.viewUnitSale && item && item.unit_measurement_sale_reference) {
          return item.unit_measurement_sale_reference
        }
        if(item && item.unit_measurement) {
          return item.unit_measurement.reference
        }
        return ''
      },
      formatQuantity(value) {
        const num = parseFloat(value)
        if (Number.isNaN(num)) {
          return (0).toFixed(4)
        }
        return num.toFixed(4)
      },
      saveViewUnitStorage() {
        Storage.setValue('deposits_query_view_unit_sale', this.filters.viewUnitSale)
      },
      restoreViewUnitStorage() {
        if(Storage.getValue('deposits_query_view_unit_sale') !== null) {
          this.filters.viewUnitSale = Storage.getValue('deposits_query_view_unit_sale') == 'true'
        }
      },

      // PRODUCTOS
      getDetailCode(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductCode(item)
        }            
        if(item.products_compound_id) {          
          return item.products_compound.code
        }                
      },
      getDetailName(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductName(item)
        }               
        if(item.products_compound_id) {          
          return item.products_compound.name
        }                
      },       
      getProductCode(item) {
        if(item.products_id) {
          return item.product.code
        }

        if(item.products_colors_id) {
          const prod = item.products_color
          return prod.code
        }

        if(item.products_waist_id) {
          const prod = item.products_waist
          return prod.code
        }

        if(item.products_color_waist_id) {
          const prod = item.products_color_waist
          return prod.code
        }
      },      
      getProductName(item) {
        if(item.products_id) {
          return item.product.name
        }

        if(item.products_colors_id) {
          const prod = item.products_color
          return prod.name + ' (' + prod.color.name + ')'
        }

        if(item.products_waist_id) {
          const prod = item.products_waist
          return prod.name + ' (' + prod.waist.name + ')'
        }

        if(item.products_color_waist_id) {
          const prod = item.products_color_waist
          return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
        }
      },        
    }    
  }
</script>

<style>
  .deposit-query-selector {
    overflow: hidden;
    border-color: var(--app-color-border);
    background: var(--app-color-surface);
    box-shadow: var(--app-shadow-sm);
  }
  .deposit-query-selector--panel {
    border-bottom: 1px solid var(--app-color-border);
    box-shadow: none;
  }
  .deposit-query-selector__context {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 1px 0;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    line-height: 1.2;
  }
  .deposit-query-selector__context .app-icon {
    color: var(--app-color-icon);
    font-size: 11px;
  }
  .deposit-query-panel-heading .app-icon {
    color: var(--app-color-primary);
  }
  .deposit-query-selector__nav {
    display: flex;
    flex-wrap: nowrap;
    gap: 6px;
    margin: 0;
    padding: 10px 16px;
    overflow-x: auto;
    border-bottom: 1px solid var(--app-color-border);
    scrollbar-width: thin;
  }
  .deposit-query-selector__nav .nav-item {
    flex: 0 0 auto;
  }
  /* Con una sola fuente de consulta no hay navegación que elegir: se oculta
     el único tab y el selector queda como acción directa. Si se habilitan
     productos compuestos, el segundo tab hace visible el selector otra vez. */
  .deposit-query-selector__nav:has(.nav-item:only-child) {
    display: none;
  }
  .deposit-query-selector__nav .nav-link {
    padding: 7px 10px;
    border: 1px solid transparent;
    border-radius: 7px;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-medium);
    white-space: nowrap;
  }
  .deposit-query-selector__nav .nav-link:hover {
    border-color: var(--app-color-primary-200);
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
  }
  .deposit-query-selector__nav .nav-link.active {
    border-color: var(--app-color-primary-300);
    background: var(--app-color-primary-soft-hover);
    color: var(--app-color-primary-active);
  }
  /* La card ya enmarca el panel: sin borde propio y sin el padding global
     de .tab-pane, que duplicaba el margen y angostaba el buscador. */
  .deposit-query-selector__content {
    padding: 10px 12px;
    border: 0;
  }
  .deposit-query-selector__content > .tab-pane {
    padding: 0;
  }
  .deposit-query-selector__form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
  .deposit-query-selector__form .form-group {
    width: 100%;
  }
  .deposit-query-selector .form-group {
    margin-bottom: 0;
  }
  .deposit-query-selector label {
    display: block;
    margin-bottom: 4px;
    font-size: var(--app-text-xs);
    text-align: left;
  }
  .deposit-query-workspace {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  .deposit-query-context-panel {
    flex: 0 0 320px;
    max-width: 320px;
    margin-top: 8px;
  }
  .deposit-query-results {
    flex: 1;
    min-width: 0;
    margin-top: 8px;
  }
  .deposit-query-results--expanded {
    width: calc(100% - 46px);
  }
  .deposit-query-tree-card {
    overflow: hidden;
  }
  .deposit-query-panel-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0;
    padding: 12px 14px;
    border-bottom: 1px solid var(--app-color-border);
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
  }
  .deposit-query-panel-heading span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .deposit-query-panel-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 27px;
    height: 27px;
    padding: 0;
    color: var(--app-color-icon);
  }
  .deposit-query-tree-body {
    max-height: 68vh;
    overflow: auto;
    padding: 8px;
  }
  .deposit-query-context-collapsed {
    display: flex;
    flex: 0 0 34px;
    min-height: 260px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 4px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-primary);
    cursor: pointer;
    writing-mode: vertical-rl;
  }
  .tree-deposit-query {
    padding: 28px 0;
    text-align: center;
  }
  .deposit-query-tree-custom .icon:hover {
    cursor: pointer;
  }
  .deposit-query-tree-custom .vtl-node-content:hover {
    cursor: pointer;
  }   
  .deposit-stock-total {
    padding: 10px 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 9px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text);
  }
  .deposit-stock-total span {
    display: block;
    text-align: right;
    font-size: var(--app-text-md);
    font-weight: var(--app-font-semibold);
  }  
  .deposit-stock-total-title {
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .deposit-query__view-modes .custom-control {
    margin-right: 14px;
  }
  .deposit-query__switches {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  @media (min-width: 1200px) {
    .deposit-query__switches {
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      gap: 16px;
    }
    .deposit-query__switches .custom-control-label {
      white-space: nowrap;
    }
  }
  @media (max-width: 767.98px) {
    .deposit-query-selector__nav {
      padding-right: 12px;
      padding-left: 12px;
    }
    .deposit-query__view-modes .custom-control {
      display: block;
      margin: 0 0 8px;
    }
    .deposit-query-workspace {
      flex-direction: column;
    }
    .deposit-query-context-panel,
    .deposit-query-results,
    .deposit-query-results--expanded {
      width: 100%;
      max-width: none;
      flex-basis: auto;
    }
    .deposit-query-context-collapsed {
      width: 100%;
      min-height: 34px;
      flex-basis: auto;
      margin-top: 8px;
      writing-mode: horizontal-tb;
    }
    .deposit-stock-total {
      text-align: left;
    }
    .deposit-stock-total span {
      display: inline-block;
      margin-top: 4px;
      text-align: left;
    }
  }
</style>
